import { useEffect } from "react";
import MODALS from "../constants/modals";

import { useLocation } from "react-router-dom";
import { useCookies } from "react-cookie";
import { useMatomo } from "@jonkoops/matomo-tracker-react";
import { useAppDispatch } from "../hooks/redux";
import { openModal } from "../features/modals";

import ModalManager from "../managers/Modal";

import { Container, Stack } from "@mui/material";
import { Outlet } from "react-router";
import Footer from "./Footer";
import NavMenu from "./NavMenu";
import SystemNotifications from "./SystemNotifications";
import { some } from "lodash";
import ErrorPageWrapper from "../pages/ErrorPageWrapper";

const Layout: React.FC = () => {
    const location = useLocation();

    const [cookies] = useCookies(["mtm_consent", "mtm_consent_removed"]);
    const { pushInstruction } = useMatomo();
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (cookies.mtm_consent || cookies.mtm_consent_removed) {
            if (!cookies.mtm_consent_removed) {
                pushInstruction("setCookieConsentGiven");
                pushInstruction("setConsentGiven");
            }
        } else {
            const paths = [
                "/static-page/privacy",
                "/static-page/accessibility",
            ];
            if (some(paths, (path) => location.pathname.includes(path))) {
                return;
            }

            dispatch(
                openModal({
                    type: MODALS.CookieConsent,
                    ignoreIfOpen: true,
                })
            );
        }
    }, [cookies, location]);

    return (
        <Stack sx={{ minHeight: "100vh" }}>
            <NavMenu />
            <SystemNotifications />
            <Container
                sx={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    displayPrint: "block",
                }}
            >
                <ErrorPageWrapper>
                    <Outlet />
                </ErrorPageWrapper>
            </Container>
            <Footer />
            <ModalManager />
        </Stack>
    );
};

export default Layout;
